module.exports = __webpack_public_path__ + "img/image-03.98c1753c.webp";